export function groupBy<T, K extends string>(arr: T[], fn: (item: T) => K) {
  return arr.reduce<Record<string, T[]>>(
    (prev, curr) => {
      const groupKey = fn(curr);
      const group = prev[groupKey] || [];
      group.push(curr);
      return { ...prev, [groupKey]: group };
    },
    {} as Record<K, T[]>,
  );
}
